import { render, staticRenderFns } from "./CBadge.vue?vue&type=template&id=32ad6702&scoped=true"
import script from "./CBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./CBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CBadge.vue?vue&type=style&index=0&id=32ad6702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad6702",
  null
  
)

export default component.exports